import { render } from "./RequiredItemsSupplier.vue?vue&type=template&id=884118d8&scoped=true"
import script from "./RequiredItemsSupplier.vue?vue&type=script&lang=js"
export * from "./RequiredItemsSupplier.vue?vue&type=script&lang=js"

import "./RequiredItemsSupplier.vue?vue&type=style&index=0&id=884118d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884118d8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QChip,QBtnToggle,QSpace,QTooltip,QSpinner,QIcon,QDialog,QCard,QCardSection,QMarkupTable,QCardActions});qInstall(script, 'directives', {ClosePopup});
